import React from 'react';
import { Box, Heading, Text } from "@kaena1/mm-ui-components";
import { GreenCheckmark } from "@kaena1/mm-ui-icons-v3";
import styles from '../css/CustomerSupport.module.scss';
import { SvgIcon } from './SvgIcon';

export const CustomerSupport = () => {
  const items = [
    {
      key: "ShortWaitTimes",
      title: "Short Wait Times",
      content: "Typically under 2-3 minutes, plus you'll speak to an actual person.",
    },
    {
      key: "SelfServiceOptions",
      title: "Self-Service Options",
      content: "Whether you prefer to watch, read or chat, we've got you covered with how-to videos, our Help Center, FAQs, and 24/7 chat.",
    },
    {
      key: "OngoingSupport",
      title: "Ongoing Support",
      content: "Whether you've been with us for three weeks or three years, when you need help, our Care Team's here.",
    },
  ];

  return (
    <div className={styles.container}>
      <div className={styles.outerBox}>
        <div className={styles.headingContainer}>
          <Heading variant="headline" size="medium" className={styles.heading} as="h2">
            Customer support that cares
          </Heading>
        </div>
        <div className={styles.itemsContainer}>
          <Box shadow={true} className={styles.leftBox}>
            <div className={styles.leftBoxContent}>
              <Heading variant="display" size="large" className={styles.boxTitle}>
                97%
              </Heading>
              <div className={styles.subtitleContainer}>
                <Text variant="body" size="medium" className={styles.subtitle}>
                  Customer Satisfaction Rating
                </Text>
                <Text variant="legal" className={styles.content}>
                  As of May 2025
                </Text>
              </div>
            </div>
            <SvgIcon 
              src="/wp-content/themes/mintmobile/v3/assets/icons/reviews/hearts.svg"
              width={165}
              alt="Hearts"
            />
          </Box>
          <Box shadow={true} className={styles.rightBox}>
            {items.map((item) => (
              <div key={item.key} className={styles.item}>
                <GreenCheckmark className={styles.icon} />
                <div className={styles.itemContent}>
                  <Heading variant="title" size="small" className={styles.title} as="h3">
                    {item.title}
                  </Heading>
                  <Text variant="body" size="small" className={styles.content}>
                    {item.content}
                  </Text>
                </div>
              </div>
            ))}
          </Box>
        </div>
      </div>
    </div>
  );
};